var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.title)?_c('div',{staticClass:"px-4 pt-3 pb-1 text-subtitle-1 font-weight-medium"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('div',{ref:"chartContainer",staticStyle:{"width":"100%","height":"520px"}})])}
var staticRenderFns = []

export { render, staticRenderFns }